import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./components/login/login.tsx";
import Dashboard from "./components/dashboard/dashboard.tsx";
import ProtectedRoute from "./components/ProtectedRoute.tsx";
import Employee from "./components/employee_portal/employee.tsx";
import CallbackRequests from "./components/callback_requests/callback_requests.tsx";
import ReportsTracker from "./components/reports_tracker/reports_tracker.tsx";
import Clientpanel from "./components/client_panel/client_panel.tsx";
import DietPanel from "./components/diet_panel/diet_panel.tsx";
import SubscriptionAlert from "./components/subscription_alert/subscription_alert.tsx";
import BannerManager from "./components/banner_manager/banner_manager.tsx";
import Transformation from "./components/transformation/transformation.tsx";
import ECommercePortal from "./components/e_commerce_portal/e_commerce_portal.tsx";
import Payments from "./components/payments/payments.tsx";
import ChatSupport from "./components/chat_support/chat_support.tsx";
import PageNotFound from "./components/404_page_not_found/page_not_found.tsx";
import SendNotification from "./components/send_notification/send_notification.tsx";
import CouponCode from "./components/coupon_code/coupon_code.tsx";
import ReferralCode from "./components/referral_code/referral_code.tsx";
import Blogs from "./components/blogs/blogs.tsx";
import SubscriptionPlans from "./components/subscription-plans/subscription_plans.tsx";
import TrackOrders from "./components/e_commerce_portal/track_orders/track_orders.tsx";
import Products from "./components/e_commerce_portal/products/products.tsx";
import TotalUserCount from "./components/total_user_count/total_user_count.tsx";
import ManageDiet from "./components/client_panel/manage_diet/manage_diet.tsx";
// import ReportsTracker from "./components/client_panel/reports_tracker/reports_tracker.tsx";
import Sessions from "./components/sessions/sessions.tsx";
import InterestedClients from "./components/All_interested_clients/interested_clients.tsx";
import FestivalSalesProducts from "./components/festival_sales/festival_sales_products.tsx";
import FestivalSalesSubscription from "./components/festival_sales/festival_sales_subscription.tsx";
import LeadFormMeta from "./components/lead_form/lead_form.tsx";
import LeadFormGoogle from "./components/lead_form_google/lead_form_google.tsx";
import ReportsTrackerNotRegistered from "./components/reports_tracker/reports_tracker_not_registered.tsx"
import LiveChatWebsite from "./components/live_chat_website/live_chat_website.tsx";
import PaymentLink from "./components/payment_link/payment_link.tsx";

function App() {
  const token = localStorage.getItem("token");

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="*" element={<PageNotFound />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={token == "" ? <Login /> : <Dashboard />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee-portal"
            element={
              <ProtectedRoute>
                <Employee />
              </ProtectedRoute>
            }
          />
          <Route
            path="/callback-requests"
            element={
              <ProtectedRoute>
                <CallbackRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/report-tracker"
            element={
              <ProtectedRoute>
                <ReportsTracker />
              </ProtectedRoute>
            }
          />
          <Route
            path="/report-tracker-not-registered"
            element={
              <ProtectedRoute>
                <ReportsTrackerNotRegistered />
              </ProtectedRoute>
            }
          />
          <Route
            path="/interested-clients"
            element={
              <ProtectedRoute>
                <InterestedClients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sessions"
            element={
              <ProtectedRoute>
                <Sessions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blogs"
            element={
              <ProtectedRoute>
                <Blogs />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/client-panel"
            element={
              <ProtectedRoute>
                <Clientpanel />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/send-diets"
            element={
              <ProtectedRoute>
                <ManageDiet />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/client-panel/manage-diet"
            element={
              <ProtectedRoute>
                <ManageDiet />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/client-panel/reports-tracker"
            element={
              <ProtectedRoute>
                <ReportsTracker />
              </ProtectedRoute>
            }
          />
          <Route
            path="/diet-panel"
            element={
              <ProtectedRoute>
                <DietPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription-alert"
            element={
              <ProtectedRoute>
                <SubscriptionAlert />
              </ProtectedRoute>
            }
          />
          <Route
            path="/banner-manager"
            element={
              <ProtectedRoute>
                <BannerManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transformation"
            element={
              <ProtectedRoute>
                <Transformation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/e-commerce-portal"
            element={
              <ProtectedRoute>
                <ECommercePortal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/e-commerce-portal/products"
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />
          <Route
            path="/e-commerce-portal/track-orders"
            element={
              <ProtectedRoute>
                <TrackOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments"
            element={
              <ProtectedRoute>
                <Payments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat-support"
            element={
              <ProtectedRoute>
                <ChatSupport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/send-notification"
            element={
              <ProtectedRoute>
                <SendNotification />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coupon-codes"
            element={
              <ProtectedRoute>
                <CouponCode />
              </ProtectedRoute>
            }
          />
          <Route
            path="/referral-codes"
            element={
              <ProtectedRoute>
                <ReferralCode />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription-plans"
            element={
              <SubscriptionPlans>
                <ReferralCode />
              </SubscriptionPlans>
            }
          />
          <Route
            path="/user-statistics"
            element={<TotalUserCount></TotalUserCount>}
          />
          <Route
            path="/festival-sales-products"
            element={<FestivalSalesProducts></FestivalSalesProducts>}
          />
          <Route
            path="/festival-sales-subscription"
            element={<FestivalSalesSubscription></FestivalSalesSubscription>}
          />
          <Route
            path="/lead-form-meta"
            element={<LeadFormMeta></LeadFormMeta>}
          />
          <Route
            path="/lead-form-google"
            element={<LeadFormGoogle></LeadFormGoogle>}
          />
          <Route
            path="/live-website-chat"
            element={<LiveChatWebsite></LiveChatWebsite>}
          />
          <Route
            path="/generate-payment-link"
            element={<PaymentLink></PaymentLink>}
          />
          {/* Add other routes as needed */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
